import * as React from 'react';

import { createIcon } from '../Icon';
export const RotateCwIcon = createIcon(
  <React.Fragment>
    <polyline points="23 4 23 10 17 10" />
    <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10" />
  </React.Fragment>,
  'RotateCwIcon'
);
